import { createSlice } from "@reduxjs/toolkit";

const overviewSlice = createSlice({
    name: "overview",
    initialState: {
        isLoading: true,
        irregularities: [],
        bankAccountDetails: [],
        inFlowList: {},
        outFlowList: {},
        overviewData: {},
        tabCounts: {}
    },
    reducers: {
        setAllOverviewData: (state, { payload }) => {
            state.inFlowList = payload.inFlowList;
            state.outFlowList = payload.outFlowList;
            state.isLoading = payload.isLoading;
            state.irregularities = payload.irregularities;
            state.bankAccountDetails = payload.bankAccountDetails;
            state.overviewData = payload.overview;
            state.tabCounts = payload.tabCounts;
        },
        setOverviewLoading: (state, { payload }) => {
            state.isLoading = payload;
        },
        setIrregularities: (state, { payload }) => {
            state.irregularities = payload;
        },
        setInFlowList: (state, { payload }) => {
            state.inFlowList = payload;
        },
        setOutFlowList: (state, { payload }) => {
            state.outFlowList = payload;
        },
        setOverviewAccountDetails: (state, { payload }) => {
            state.bankAccountDetails = payload;
        },
        setOveriviewData: (state, { payload }) => {
            state.overview = payload;
        }
    }
});

export const { setAllOverviewData, setInFlowList, setIrregularities, setOutFlowList, setOverviewAccountDetails, setOverviewLoading, setOveriviewData } = overviewSlice.actions;

export default overviewSlice.reducer;